import { createSlice } from "@reduxjs/toolkit";

const gymInitState = {
  isLoading: false,
  gyms: [],
  gym: {},
  schedule: {},
  schedules: [],
};
const gymReducerSlice = createSlice({
  name: "gym",
  initialState: gymInitState,
  reducers: {
    changeGymLoading: (state, action) => {
      if (state.isLoading !== action.payload) {
        state.isLoading = action.payload;
      }
    },
    addGymState: (state, action) => {
      state.gyms.unshift(action.payload);
      state.isLoading = false;
    },
    setGymById: (state, action) => {
      state.gym = action.payload;
      state.isLoading = false;
    },
    setGymState: (state, action) => {
      state.gyms = action.payload.gyms || state.gyms;
      state.isLoading = false;
    },
    editgymState: (state, action) => {
      state.gyms = state.gyms.map((gym) => {
        if (action.payload._id === gym._id) {
          gym = action.payload;
        }
        return gym;
      });
      state.isLoading = false;
    },
    deleteGymState: (state, action) => {
      state.gyms = state.gyms.filter((gym) => gym._id !== action.payload);
      state.isLoading = false;
    },
    addGymScheduleState: (state, action) => {
      state.schedules.push(action.payload);
      state.isLoading = false;
    },
    deleteGymScheduleState: (state, action) => {
      state.schedules = state.schedules.filter(
        (schedule) => schedule._id !== action.payload
      );
      state.isLoading = false;
    },
    setScheduleGymState: (state, action) => {
      state.schedules = action.payload.schedules || state.schedules;
      state.isLoading = false;
    },

  },
});

export const {
  changeGymLoading,
  setGymState,
  addGymState,
  setGymById,
  editgymState,
  deleteGymState,
  addGymScheduleState,
  deleteGymScheduleState,
  setScheduleGymState,
} = gymReducerSlice.actions;

export default gymReducerSlice.reducer;
